import styled from 'styled-components';
import colors from '../../../theme/Colors';
import theme from 'styled-theming';

interface ButtonProps {
    active?: boolean;
}

const mainColor = theme('brand', {
    brenntag: colors.brenntag.primary, 
    bcd: colors.bcd.secondary
});

export const SPaginationButton = styled.button<ButtonProps>`
    height: 38px;
    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.05);
    background-color: #ffffff;
    font-family: Verdana;
    font-size: 13px;
    font-weight: bold;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.54;
    letter-spacing: normal;
    text-align: center;
    color: ${mainColor};
    border: none;
    cursor: pointer;
    padding: 10px 10px 10px 13px;
    outline: 0;

    background-color: ${props => props.active && mainColor }
    ${props => props.active && 
        `color: white;`
    };

    &:disabled {
        color: #999999;
        cursor: default;
    }
    &:first-child {
        margin-right: 10px;
        padding: 10px 20px 10px 20px;
    }
    &:last-child {
        margin-left: 10px;
        padding: 10px 20px 10px 20px;
    }

    &:nth-child(n + 2):not(:last-child):not(:nth-last-child(2)) {
        border-right: 1px solid #dddddd;
    }
`;